// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{padding:0;margin:0;list-style:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;font-family:Microsoft YaHei,微软雅黑,Microsoft JhengHei,华文细黑,STHeiti,MingLiu}a{text-decoration:none}html{overflow:hidden}body,html{width:100%;height:100%}body{font-size:.8rem;padding-right:0!important;color:#fff}#app{height:100%}", ""]);
// Exports
module.exports = exports;
